import { createMuiTheme } from 'material-ui/styles'
import grey from 'material-ui/colors/grey'

const paradeTheme = createMuiTheme({
  palette: {
    primary: {
      light: grey[500],
      main: grey[800],
      dark: grey[900],
    }
  }
})

export default paradeTheme



// WEBPACK FOOTER //
// ./src/styles/theme.js